<template>
  <div class="globalAlerts" :class="{ 'globalAlertsEmpty': !this.globalAlerts.length }">
    <transition-group name="list">
      <div v-for="item in this.globalAlerts"
        :class="{ 'globalAlertsSuccess': item.status == 'success', 'globalAlertsError': item.status == 'error' }"
        :key="item.alert_id" @click="this.removeAlertById(item.alert_id)">
        {{ item.message }}
      </div>
    </transition-group>
  </div>
</template>
<script>
export default {
  name: "GlobalAlerts",
  methods: {

  },
  computed: {

  }
}
</script>
<style scoped>
.globalAlerts {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 1001;
  transition: all .3s;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 5px;
}

.globalAlertsEmpty {
  opacity: 0;
  pointer-events: none;
}

.globalAlerts div {
  padding: 10px;
  border-radius: 5px;
  backdrop-filter: blur(2px);
  padding-right: 20px;
}

.globalAlertsError {
  background-color: #fc444487;
}

.globalAlertsSuccess {
  background-color: #00ff0d87;
}


/* Анимация появления */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* Анимация удаления */
.list-leave-active {
}
</style>
